import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD__list_base_generic } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_base_generic';
import { G_BUTTON__graph_field_list_item_add } from './_buttons/list/G_BUTTON__graph_field_list_item_add';
import { G_BUTTON__graph_field_list_item_remove } from './_buttons/list/G_BUTTON__graph_field_list_item_remove';

interface PROPS {
  field: FIELD__base;
  is_list_item?: boolean;
}

export function G_GRAPH_FIELD__buttons_input({ field, is_list_item }: PROPS) {
  /*
   * RENDERS
   */

  function render_button_list_item_add() {
    if (!(field instanceof FIELD__list_base_generic)) return null;

    return <G_BUTTON__graph_field_list_item_add {...{ field }} />;
  }
  function render_button_list_item_remove() {
    if (!is_list_item) return null;

    return <G_BUTTON__graph_field_list_item_remove {...{ field }} />;
  }

  return (
    <div className="flex flex-row items-center gap-1 transition-opacity">
      {render_button_list_item_add()}
      {render_button_list_item_remove()}
    </div>
  );
}
